import { render, staticRenderFns } from "./survey-inactive.component.html?vue&type=template&id=81c791b2&scoped=true&"
import script from "./survey-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./survey-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./survey-inactive.component.scss?vue&type=style&index=0&id=81c791b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c791b2",
  null
  
)

export default component.exports